import React from "react";
import { SourceSelector } from "@me8eon/source_selector-new";
import { Icon } from "@me8eon/icons";
import styles from "../AgentSelectorTextAreaPlugin/AgentChip.module.scss";
import useCompassStore, { CompassScope } from "../../../../store/compassStore";
import { useTranslation } from "@me8eon/translation";
import { translateKey } from "../../../../util/translate";

const SCOPE_SOURCES = [
    {
        id: "local",
        name: translateKey("compassScopeSelector.localSearch"),
        description: translateKey("compassScopeSelector.localDescription"),
    },
    {
        id: "compass-wide",
        name: translateKey("compassScopeSelector.compassWideSearch"),
        description: translateKey("compassScopeSelector.compassWideDescription"),
    },
];

export const CompassSourceSelectorTextAreaPlugin: React.FC<{ isBottom?: boolean }> = ({ isBottom }) => {
    const { compassScope, setCompassScope } = useCompassStore();
    const t = useTranslation();

    const handleClearToCompassWide = (e: React.MouseEvent) => {
        e.stopPropagation();
        setCompassScope("compass-wide");
    };

    const handleClearToLocal = (e: React.MouseEvent) => {
        e.stopPropagation();
        setCompassScope("local");
    };

    return (
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "8px", marginLeft: "5px" }}>
            <SourceSelector
                sources={SCOPE_SOURCES}
                selectedSource={compassScope}
                setSelectedSource={(id) => id && setCompassScope(id as CompassScope)}
                icon="compass_scope"
                iconLabel={t("compassScopeSelector.iconLabel")}
                dropdownTitle={t("compassScopeSelector.title")}
                top={!isBottom}
            />
            {compassScope === "local" && (
                <div className={styles.chipContainer}>
                    <span>{t("compassScopeSelector.localSearch")}</span>
                    <div>
                        <button
                            className={styles.closeButton}
                            onClick={handleClearToCompassWide}
                            title={t("compassScopeSelector.resetToCompassWide")}
                        >
                            <Icon name="close" />
                        </button>
                    </div>
                </div>
            )}
            {compassScope === "compass-wide" && (
                <div className={styles.chipContainer}>
                    <span>{t("compassScopeSelector.compassWideSearch")}</span>
                    <div>
                        <button
                            className={styles.closeButton}
                            onClick={handleClearToLocal}
                            title={t("compassScopeSelector.switchToLocal")}
                        >
                            <Icon name="close" />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};
